/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250403-p4.png',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250403-p5.png',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250403-p6.png',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-p2.jpg?v=1752634528',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-p3.jpg?v=1752634529',
    
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250403-p1.png?v=1751425208',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250403-p2.png?v=1751425208',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250403-p3.png?v=1751425209',
    '',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-p1.jpg?v=1752634528',
    
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250710-img6.png?v=1752133025',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250710-img4.png?v=1752133025',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250710-img2.png?v=1752133024',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-basic-batarry4.jpg?v=1752634528',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-basic-batarry5.jpg?v=1752636271',
    
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-ice-batarry1.jpg',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-ice-batarry2.png',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-ice-batarry3.jpg',
    '',
    'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-ice-batarry5.jpg',
  ]

      
    // 'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-basic-batarry1.png',
    // 'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-basic-batarry2.jpg',
    // 'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-basic-batarry3.png',
    // 'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-basic-batarry4.jpg',
    // 'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250716-basic-batarry5.jpg',

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight =
          $('.time-part').height() + $('.sp-header-top').height() - 12
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }

    // new Swiper(".sp-swiper1", {
    //   direction: "horizontal",
    //   autoplay: true,
    //   autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false,
    //   },
    //   loop: true,
    // });
  }

  mainRender()

  let prods = window.product
  function getCur() {
    const color = $('#sp-color .active').attr('data-val')
    const num = $('#sp-number .active').attr('data-val')
    return prods.filter(item => item.option1 == color && item.option2 == num)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price / 100) * num).toFixed(0)
    let compare = ((getCur().compare_at_price / 100) * num).toFixed(0)
    // if (price > 50) {
    //   // $('.product-part .sp-tip').css('display', 'flex')
    //   $('.product-part .btn-free').css('display', 'flex')
    // } else {
    //   // $('.product-part .sp-tip').hide()
    //   $('.product-part .btn-free').hide()
    // }
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.product-part .price-group .sp-row span').html(`${off_font}`)
  }

  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })
  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
  $(function () {
    $('.sp-option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      // style选项

      let colorOptions = $('#sp-color .sp-option.active').index()
      let numberOptions = $('#sp-number .sp-option.active').index()
      let _index = numberOptions * 5 + colorOptions
      console.log(_index)
      $('.product-part .sp-img-p')[0].src = spImgList[_index]
      if (colorOptions == 0) {
        $('.product-part .sp-name').text('US(110V)')
      } else {
        $('.product-part .sp-name').text('AU(220V)')
      }
      if (numberOptions == 0) {
        $('.product-part .sp-brand').hide()
      } else if (numberOptions == 1) {
        $('.product-part .sp-brand').show()
        $('.product-part .sp-brand .sp-save').text(90)
      } else if (numberOptions == 2) {
        $('.product-part .sp-brand').show()
        $('.product-part .sp-brand .sp-save').text(140)
      }

      // 改变选项显示禁用
      let type = $(this).parent().attr("id")
      const disableIndexMap = [{
        color: 3,
        style: 1
      },{
        color: 3,
        style: 3
      }]
      if (type == 'sp-color') {
        let val = disableIndexMap.find(item => item.color == colorOptions)
        $("#sp-number").children().removeClass("disbled");
        $("#sp-number").children().css("pointer-events", "auto");
        if (val) {
          let element = $("#sp-number").children().eq(val.style)
          element.addClass("disbled");
          element.css("pointer-events", "none")
        }
      } else if (type == 'sp-number') {
        let val = disableIndexMap.find(item => item.style == numberOptions)
        $("#sp-color").children().removeClass("disbled");
        $("#sp-color").children().css("pointer-events", "auto");
        if (val) {
          let element = $("#sp-color").children().eq(val.color);
          element.addClass("disbled");
          element.css("pointer-events", "none")
        }
      }
      
      changePrice()
    })

    // 购物车加购动效
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-header-top .sp-cart .num').show()
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    let initNum = 0
    $('.product-part .cart-btn').click(function () {
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
            $('#cardNum').removeClass('sp-gray')
          })
        },
        dataType: 'json',
      })
      $('#cardNum').removeClass('sp-gray')
      // handleAddToCart(initNum);

      var img = $('.product-part .sp-img-p')
      // var img = $(".product-part .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.product-part').append(flyer)
      $('.sp_clone').css({
        width: img[0].width,
        height: img[0].height,
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          top: finish[0].offsetTop + $('.time-part').height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach()
            }
          )
        }
      )
    })
  })
})
